export default {"src":"/_next/static/media/security-small.02c682a8.svg","height":1000,"width":1200,"blurWidth":0,"blurHeight":0};